package com.evoapps.evoshift.domain.usecase.user

import com.evoapps.evoshift.domain.model.DataExport
import com.evoapps.evoshift.domain.provider.DeviceInfoProvider
import com.evoapps.evoshift.domain.repository.DataExportRepository

/**
 * "Download my data" (GDPR Art. 15/20, art. 149 KP): the server builds a ZIP of everything about
 * the signed-in person and returns a link valid for 24 hours, in the app's language.
 */
class ExportMyDataUseCase(
    private val repository: DataExportRepository,
    private val deviceInfo: DeviceInfoProvider
) {
    suspend operator fun invoke(): Result<DataExport> = repository.exportMyData(deviceInfo.getLanguage())
}

/**
 * "Export workplace data" for its owner (everything), financial manager (no billing) or
 * operational manager (no pay or contact data); with [employeeUid] one person's records, for
 * answering their request. The server decides what the caller may see.
 */
class ExportWorkplaceDataUseCase(
    private val repository: DataExportRepository,
    private val deviceInfo: DeviceInfoProvider
) {
    suspend operator fun invoke(workplaceId: String, employeeUid: String? = null): Result<DataExport> {
        if (workplaceId.isBlank()) return Result.failure(IllegalArgumentException("workplaceId is required"))
        return repository.exportWorkplace(workplaceId, employeeUid, deviceInfo.getLanguage())
    }
}
